import React, { useEffect, useState } from "react";

const DEFAULT_LINKS = [
  { label: "Product",  scrollTo: "" },
  { label: "Features", scrollTo: "features" },
  { label: "Pricing",  scrollTo: "pricing" },
  { label: "Download", scrollTo: "" },
];

export default function CommandNav({
  logoSrc,
  logoAlt,
  navLinks,
  lang,
  setLang,
  onLogoClick,
  onLogin,
  onSignup,
  onBack,
  backText,
  signInText,
  signUpText,
  showSignIn = true,
  showSignUp = true,
  showNavLinks = true,
}){
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = (navLinks && navLinks.length > 0) ? navLinks : DEFAULT_LINKS;

  const handleLink = (nl) => (e) => {
    if (nl.scrollTo) {
      e.preventDefault();
      const el = document.getElementById(nl.scrollTo);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav className="cmd-nav" data-scrolled={scrolled ? "true" : "false"} aria-label="Primary">
      <div className="cmd-nav__inner">
        <a
          href="#"
          className="cmd-nav__logo"
          aria-label="Command — home"
          onClick={(e) => {
            e.preventDefault();
            if (onLogoClick) onLogoClick();
            else window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <span className="cmd-logo-tile">
            <img src={logoSrc} alt={logoAlt || ""} />
          </span>
        </a>

        {showNavLinks && (
          <div className="cmd-navpill cmd-hide-on-small">
            {links.map((nl, i) => (
              <a
                key={`${nl.label}-${i}`}
                href={nl.scrollTo ? `#${nl.scrollTo}` : "#"}
                onClick={handleLink(nl)}
              >
                {nl.label}
              </a>
            ))}
          </div>
        )}

        <div className="cmd-nav__actions">
          <span className="cmd-lang cmd-hide-on-small" role="group" aria-label="Language">
            <button
              type="button"
              className={lang === "en" ? "active" : ""}
              aria-pressed={lang === "en"}
              onClick={() => setLang && setLang("en")}
            >EN</button>
            <span className="cmd-lang__sep">/</span>
            <button
              type="button"
              className={lang === "ar" ? "active" : ""}
              aria-pressed={lang === "ar"}
              onClick={() => setLang && setLang("ar")}
            >ع</button>
          </span>
          {showSignIn && (
            <button type="button" className="cmd-btn-ghost cmd-hide-on-small" onClick={onLogin}>
              {signInText || "Sign in"}
            </button>
          )}
          {showSignUp && (
            <button type="button" className="cmd-btn-grad" onClick={onSignup}>
              {signUpText || "Get started"}
            </button>
          )}
          {onBack && (
            <button type="button" className="cmd-btn-ghost" onClick={onBack}>
              {backText || "Back"}
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}
